// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/published_work_status.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/published_work_status.proto.
 */
export const file_studyo_today_schools_v1_resources_published_work_status = /*@__PURE__*/
  fileDesc("Cj1zdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvcHVibGlzaGVkX3dvcmtfc3RhdHVzLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMqzAEKE1B1Ymxpc2hlZFdvcmtTdGF0dXMSJQohUFVCTElTSEVEX1dPUktfU1RBVFVTX1VOU1BFQ0lGSUVEEAASHwobUFVCTElTSEVEX1dPUktfU1RBVFVTX0RSQUZUEAESIwofUFVCTElTSEVEX1dPUktfU1RBVFVTX1BVQkxJU0hFRBACEiMKH1BVQkxJU0hFRF9XT1JLX1NUQVRVU19TQ0hFRFVMRUQQAxIjCh9QVUJMSVNIRURfV09SS19TVEFUVVNfQ0FOQ0VMTEVEEARCKaoCJlN0dWR5by5Ub2RheS5TY2hvb2xzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.schools.v1.resources.PublishedWorkStatus.
 */
export const PublishedWorkStatusSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_published_work_status, 0);

/**
 * All possible states of a published work.
 *
 * @generated from enum studyo.today.schools.v1.resources.PublishedWorkStatus
 */
export const PublishedWorkStatus = /*@__PURE__*/
  tsEnum(PublishedWorkStatusSchema);

